import {
  SeFriendlyBookingButtonLocation,
  seFriendlyPhoneNumber,
} from 'app/SeFriendly/constants'
import styles from './index.module.scss'
import logEvent from 'utils/logEvent'
import { RudderEvent } from 'constants/rudderEvents'
import Button from 'component_library/1_Atoms/Button'
import { useRouter } from 'next/router'
import { pageRoutes } from 'constants/routing'
import useBreakpoint from 'hooks/useBreakPoint'
import { callRudderEventForBookingCTAclicked } from 'app/ProviderSearch/rudderEventUtils'
import { getBookBannerCTAClassNames } from 'app/SeFriendly/helpers'

type StateBookBannerProps = {
  sefriendlyPageType?: string
  sefriendlyProvidersType?: string
}

const StateBookBanner: React.FC<StateBookBannerProps> = ({
  sefriendlyPageType = '',
  sefriendlyProvidersType = '',
}) => {
  const router = useRouter()
  const { isMobileScreen, isLargeSize } = useBreakpoint()
  const { phoneNumber, formattedPhoneNumber } = seFriendlyPhoneNumber
  const isMobileOrTabletScreen = isMobileScreen || isLargeSize
  const adBannerHeading = 'Book a session and get the help you need now'
  const adBannerDescription =
    'You deserve dedicated time with a mental health professional — it can be life-changing.'

  const handleSeFriendlyPhoneCall = () => {
    window.location.href = `tel:${phoneNumber}`

    logEvent(RudderEvent.PHONE_NUMBER_CLICKED, {
      phone_number: formattedPhoneNumber,
    })
  }

  const onFindProviderBtnClick = (event) => {
    router.push(pageRoutes.PROVIDER_SEARCH)
    callRudderEventForBookingCTAclicked(
      SeFriendlyBookingButtonLocation.SE_FRIENDLY_BOOK_BANNER_SECTION,
      (event.currentTarget as HTMLElement).className,
      (event.currentTarget as HTMLElement).innerText
    )
  }

  const seFriendlyBookBannerCTAClassNames = getBookBannerCTAClassNames(
    sefriendlyPageType,
    sefriendlyProvidersType
  )

  return (
    <div className={styles.BookAdBanner}>
      <div className={styles.BookAdBanner__innerContainer}>
        {isMobileOrTabletScreen && (
          <div className={styles.BookAdBanner__mobileHeaderSection}>
            <h2 className={styles.BookAdBanner__heading}>{adBannerHeading}</h2>
            <div className={styles.BookAdBanner__mainImage} />
          </div>
        )}
        <div className={styles.BookAdBanner__infoSection}>
          {!isMobileOrTabletScreen && (
            <div className={styles.BookAdBanner__mainImage} />
          )}
          <div className={styles.BookAdBanner__content}>
            {!isMobileOrTabletScreen && (
              <h2 className={styles.BookAdBanner__heading}>
                {adBannerHeading}
              </h2>
            )}
            <div className={styles.BookAdBanner__description}>
              {adBannerDescription}
            </div>
            <div className={styles.BookAdBanner__buttonContainer}>
              <Button
                variant="primary"
                theme="v2"
                className={seFriendlyBookBannerCTAClassNames.findProviderCTA}
                onClick={onFindProviderBtnClick}
              >
                Find a provider
              </Button>
              <Button
                variant="quinary"
                theme="v2"
                className={seFriendlyBookBannerCTAClassNames.callNumberCTA}
                onClick={handleSeFriendlyPhoneCall}
              >
                Call {isMobileScreen ? 'now' : formattedPhoneNumber}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StateBookBanner
